var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manager-wrapper"},[_vm._t("default",null,{"managers":_vm.managersData,"holdings":_vm.holdingsPageData,"loading":_vm.loading,"managersFinished":_vm.managersFinished,"holdingsFinished":_vm.holdingsFinished,"holdLoadMore":_vm.holdLoadMore})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }